module.exports = __webpack_public_path__ + "static/img/aboutUs-mobile.dfae3c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs-mobile.png
// module id = R0iZ
// module chunks = 1